/*
* Copyright 2026 Tecnalia, Basque Research & Technology Alliance (BRTA)
*
* Licensed under the Apache License, Version 2.0 (the "License");
* you may not use this file except in compliance with the License.
* You may obtain a copy of the License at
*
*    http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
*
*  SPDX-License-Identifier: Apache-2.0
*/

import { HttpHandlerFn, HttpHeaders, HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import { AuthService } from '../services/auth.service';
import { catchError, throwError } from 'rxjs';
import { inject } from '@angular/core';

export const ApiInterceptor: HttpInterceptorFn = (
	req: HttpRequest<unknown>,
	next: HttpHandlerFn
) => {
	const authSvc = inject(AuthService);

	let headers: HttpHeaders = req.headers;
	headers = headers.set('Content-Type', 'application/json');

	headers = authSvc.addTokenToEndpointRequestHeaders(headers, req.url);

	let clonedRequest = req.clone({ headers });

	return next(clonedRequest).pipe(
		catchError((error) => {
			authSvc.checkEndpointResponseError(error);
			return throwError(() => error);
		})
	);
}